import styled, { css } from 'styled-components'
import { MiniRounding } from '@chegg-wt/core/theme/sunkist/borders'
import { MenuBox } from '@chegg-wt/core/theme/sunkist/menu'
import { HeadingReset, ButtonReset } from '@chegg-wt/core/theme/sunkist/resets'
import { Heading2, Ellipsize } from '@chegg-wt/core/theme/sunkist/typography'

import { Icon as FIcon, ButtonContainer } from '@chegg-wt/core/components/Folders/styled'

import { Gear as OriginalGear } from '@chegg-wt/core/components/Icon'

import OriginalProjectMenu from '@chegg-wt/core/components/Folders/shared/ProjectMenu'
import OriginalFolderSettingsMenu from '@chegg-wt/core/components/Folders/shared/FolderSettingsMenu'
import { values } from '@chegg-wt/core/theme/sunkist/spacing'
import {
  SunkistIconColors,
  SunkistIconHoverState,
} from '@chegg-wt/core/components/Icon/styled'
import { themeBreakPoints } from '@chegg-wt/core/theme/theme'

export const ListTitle = styled.h2`
  ${HeadingReset};
  ${Heading2};
  ${Ellipsize};
`

export const FolderListMenuButton = styled.button`
  ${ButtonReset};

  @media (min-width: ${({ theme }) => themeBreakPoints.small(theme)}) {
    display: none;
  }
`

export const GearIcon = styled(OriginalGear)`
  ${SunkistIconColors};
  ${SunkistIconHoverState};
`

export const Icon = styled(FIcon)``

export const FolderSettingsMenuButton = styled(ButtonContainer)``

export const SubTitleContainer = styled.div`
  display: flex;

  & > * + * {
    margin-left: ${values.xsmall};
  }
`

export const ProjectMenu = styled(OriginalProjectMenu)`
  width: 250px;
`

const SunkistBoxShape = css`
  ${MiniRounding};
  padding: ${values.xsmall};
`

const BoxHinting = css`
  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.05);
`

export const MenuContainer = styled.nav`
  ${MenuBox};
  ${SunkistBoxShape};
  ${BoxHinting};
  max-height: 275px;
  overflow-y: auto;

  @media (min-width: ${({ theme }) => themeBreakPoints.small(theme)}) {
    display: none;
  }
`

export const FolderSettingsMenu = styled(OriginalFolderSettingsMenu)`
  ${BoxHinting};
`

export const PositionedItemsLayout = styled.div`
  position: relative;

  & ${FolderSettingsMenu}, & ${MenuContainer} {
    position: absolute;
    top: 100%;
    z-index: 1;
  }

  & ${FolderSettingsMenu} {
    right: 0;
    width: 100%;
    max-width: 180px;
  }
`
